export default function filterComposers(composers) {
  const filteredComposers = composers.map((era) => {
    let eraComposersWithFavoriteWorks = era.composers.map((composer) => {
      const favoriteComposerWorks = composer.works.filter(work => work.favorite === true)
      if (favoriteComposerWorks && favoriteComposerWorks.length) {
        return {
          ...composer,
          works: favoriteComposerWorks,
        };
      }
      return undefined;
    });

    eraComposersWithFavoriteWorks = eraComposersWithFavoriteWorks.filter((element) => {
      return element !== undefined;
    });


    if (eraComposersWithFavoriteWorks && eraComposersWithFavoriteWorks.length) {
      return {
        ...era,
        composers: eraComposersWithFavoriteWorks,
      };
    }
    return undefined;
  })

  return filteredComposers;
}
